import React, { useState, useEffect, useMemo } from 'react';
import './ExamModal.css';
import { BotaoDownloadExamePDF } from './FormularioExamePDF';

const VETORES = [
    { id: 1, nome: 'Triatoma infestans' },
    { id: 2, nome: 'Triatoma sordida' },
    { id: 3, nome: 'Triatoma brasiliensis' },
    { id: 4, nome: 'Triatoma pseudomaculata' },
    { id: 5, nome: 'Triatoma maculata' },
    { id: 6, nome: 'Triatoma rubrofasciata' },
    { id: 7, nome: 'Triatoma rubrovaria' },
    { id: 8, nome: 'Triatoma vitticeps' },
    { id: 9, nome: 'Triatoma melanocephala' },
    { id: 10, nome: 'Triatoma tibiamaculata' },
    { id: 11, nome: 'Triatoma petrochii' },
    { id: 12, nome: 'Triatoma circunmaculata' },
    { id: 13, nome: 'Triatoma guasu' },
    { id: 14, nome: 'Triatoma pessoai (lenti)' },
    { id: 15, nome: 'Triatoma matogrossensis' },
    { id: 16, nome: 'Triatoma williami' },
    { id: 17, nome: 'Panstrongylus megistus' },
    { id: 18, nome: 'Panstrongylus lutzi' },
    { id: 19, nome: 'Panstrongylus geniculatus' },
    { id: 20, nome: 'Panstrongylus diasi' },
    { id: 21, nome: 'Panstrongylus tupynambai' },
    { id: 22, nome: 'Panstrongylus lignarius' },
    { id: 23, nome: 'Rhodnius neglectus' },
    { id: 24, nome: 'Rhodnius prolixus' },
    { id: 25, nome: 'Rhodnius nasutus' },
    { id: 26, nome: 'Rhodnius pictipes' },
    { id: 27, nome: 'Rhodnius domesticus' },
    { id: 28, nome: 'Rhodnius robustus' },
    { id: 29, nome: 'Rhodnius brethesi' },
    { id: 30, nome: 'Eratyrus mucronatus' },
    { id: 31, nome: 'Microtriatoma trinidadensis' },
    { id: 32, nome: 'Triatoma costalimai' },
    { id: 33, nome: 'Triatoma deanei' },
    { id: 34, nome: 'Triatoma arthurneivai' },
    { id: 35, nome: 'Triatoma oliveirai' },
    { id: 36, nome: 'Triatoma wygodzisnskyi' },
    { id: 37, nome: 'Panstrongylus lenti' },
    { id: 38, nome: 'Panstrongylus rufotuberculatus' },
    { id: 39, nome: 'Cavernicola pilosa' },
    { id: 40, nome: 'Psammolestes tertius' },
    { id: 41, nome: 'Cavernicola lenti' },
    { id: 42, nome: 'Parabelminus carioca' },
    { id: 43, nome: 'Parabelminus yurupucu' },
    { id: 44, nome: 'Belminus laportei' },
    { id: 45, nome: 'Microtriatoma borbai' },
    { id: 46, nome: 'Triatoma juazeirensis' },
    { id: 47, nome: 'Outros insetos' }
];

const ExamModal = ({ isOpen, onClose, initialEtiqueta, ocorrenciaId, readOnly, existingData, fieldData, municipioNome, onSave }) => {

    const [tecnico, setTecnico] = useState('');
    const [dataExame, setDataExame] = useState(new Date().toISOString().split('T')[0]);
    const [situacao, setSituacao] = useState('Finalizado');
    const [exemplares, setExemplares] = useState([]);

    const [novoExemplar, setNovoExemplar] = useState({
        vetor: 'Triatoma sordida',
        captura: 'Intradomicílio',
        estagio: 'Adulto Macho',
        resultado: 'Negativo',
        dataLaudo: new Date().toISOString().split('T')[0]
    });

    useEffect(() => {
        if (isOpen) {
            if (existingData) {
                setTecnico(existingData.tecnico_responsavel || '');
                setDataExame(existingData.data_exame ? existingData.data_exame.split('T')[0] : '');
                
                const rawExemplares = existingData.exemplares || existingData.exames_exemplares || [];
                const exemplaresLimpos = rawExemplares.map(ex => ({
                    ...ex,
                    id: ex.id || Date.now() + Math.random(),
                    vetor: ex.vetor?.replace(/^\d+\s-\s/, '') || '',
                    captura: ex.captura?.replace(/^\d+\s-\s/, '') || '',
                    estagio: ex.estagio?.replace(/^\d+\s-\s/, '') || '',
                    resultado: ex.resultado?.replace(/^\d+\s-\s/, '') || '',
                }));
                setExemplares(exemplaresLimpos);
                setSituacao(existingData.situacao || 'Finalizado');
            } else {
                setTecnico('');
                setExemplares([]);
                setSituacao('Finalizado');
            }
        }
    }, [isOpen, existingData]);

    // Memoiza o objeto do exame para evitar regenerar o PDF a cada keystroke
    const currentExamData = useMemo(() => ({
        ...existingData,
        tecnico_responsavel: tecnico,
        data_exame: dataExame,
        situacao,
        exemplares
    }), [existingData, tecnico, dataExame, situacao, exemplares]);

    if (!isOpen) return null;

    const handleAddExemplar = () => {
        setExemplares([...exemplares, { ...novoExemplar, id: Date.now() }]);
    };

    const handleRemoveExemplar = (id) => {
        if (!readOnly) {
            setExemplares(exemplares.filter(ex => ex.id !== id));
        }
    };

    const handleSaveAll = () => {
        const dadosCompletos = {
            id: existingData?.id,
            ocorrencia_id: ocorrenciaId,
            codigo_etiqueta: initialEtiqueta,
            tecnico_responsavel: tecnico,
            data_exame: dataExame,
            exemplares,
            situacao
        };
        onSave(dadosCompletos);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content professional-modal">
                <div className="modal-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '24px' }}>🔬</span>
                        <div>
                            <h2 style={{ fontSize: '18px', margin: 0 }}>{readOnly ? 'Visualizar Exame' : 'Cadastro de Exame'}</h2>
                            <span style={{ fontSize: '12px', color: '#666' }}>Para Controle da Doença de Chagas</span>
                        </div>
                    </div>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    <h4 className="section-title">Dados do Exame</h4>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Etiqueta</label>
                            <input type="text" value={initialEtiqueta || ''} disabled className="input-readonly" />
                        </div>
                        <div className="form-group">
                            <label>Técnico Responsável *</label>
                            <input type="text" value={tecnico} onChange={e => setTecnico(e.target.value)} disabled={readOnly} placeholder="Nome do técnico" />
                        </div>
                        <div className="form-group">
                            <label>Data do Exame *</label>
                            <input type="date" value={dataExame} onChange={e => setDataExame(e.target.value)} disabled={readOnly} />
                        </div>
                        <div className="form-group">
                            <label>Situação</label>
                            <div className="radio-group">
                                <label><input type="radio" name="situacao" value="Finalizado" checked={situacao === 'Finalizado'} onChange={e => setSituacao(e.target.value)} disabled={readOnly} /> Finalizado</label>
                                <label><input type="radio" name="situacao" value="Pendente" checked={situacao === 'Pendente'} onChange={e => setSituacao(e.target.value)} disabled={readOnly} /> Pendente</label>
                            </div>
                        </div>
                    </div>

                    <hr className="divider" />
                    <h4 className="section-title">Exemplares (Laudo)</h4>

                    {!readOnly && (
                        <div className="exemplar-form-box">
                            <div className="form-grid-compact">
                                <div className="form-group span-3">
                                    <label>Vetor (Espécie) *</label>
                                    <select value={novoExemplar.vetor} onChange={e => setNovoExemplar({ ...novoExemplar, vetor: e.target.value })}>
                                        {VETORES.map(v => <option key={v.id} value={v.nome}>{v.nome}</option>)}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Captura</label>
                                    <select value={novoExemplar.captura} onChange={e => setNovoExemplar({ ...novoExemplar, captura: e.target.value })}>
                                        <option value="Intradomicílio">Intra</option>
                                        <option value="Peridomicílio">Peri</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Estágio</label>
                                    <select value={novoExemplar.estagio} onChange={e => setNovoExemplar({ ...novoExemplar, estagio: e.target.value })}>
                                        <option value="Ninfa">Ninfa</option>
                                        <option value="Adulto Macho">Macho</option>
                                        <option value="Adulto Fêmea">Fêmea</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Resultado</label>
                                    <select value={novoExemplar.resultado} onChange={e => setNovoExemplar({ ...novoExemplar, resultado: e.target.value })}
                                        style={{ fontWeight: 'bold', color: novoExemplar.resultado.includes('Positivo') ? '#d32f2f' : '#388e3c' }}>
                                        <option value="Positivo">Positivo</option>
                                        <option value="Negativo">Negativo</option>
                                        <option value="Não Examinado">N/E</option>
                                    </select>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right', marginTop: '10px' }}>
                                <button className="btn-add-compact" onClick={handleAddExemplar}>+ Incluir no Laudo</button>
                            </div>
                        </div>
                    )}
                    <div className="table-container">
                        <table className="sioc-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Vetor Identificado</th>
                                    <th>Captura</th>
                                    <th>Estágio</th>
                                    <th>Resultado</th>
                                    {!readOnly && <th style={{ width: '50px' }}></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {exemplares.length === 0 ? (
                                    <tr><td colSpan={readOnly ? 5 : 6} style={{ textAlign: 'center', color: '#999', fontStyle: 'italic', padding: '20px' }}>Nenhum exemplar inserido.</td></tr>
                                ) : (
                                    exemplares.map((ex, idx) => (
                                        <tr key={ex.id || idx}>
                                            <td>{idx + 1}</td>
                                            <td style={{ fontWeight: '600', color: '#333' }}>{ex.vetor}</td>
                                            <td>{ex.captura}</td>
                                            <td>{ex.estagio}</td>
                                            <td>
                                                <span className={ex.resultado?.includes('Positivo') ? 'badge-pos' : 'badge-neg'}>
                                                    {ex.resultado}
                                                </span>
                                            </td>
                                            {!readOnly && (
                                                <td>
                                                    <button className="btn-icon-remove" title="Remover" onClick={() => handleRemoveExemplar(ex.id)}>🗑️</button>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="btn-cancel" onClick={onClose}>Cancelar</button>
                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                        {existingData && (
                            <BotaoDownloadExamePDF 
                                examData={currentExamData} 
                                fieldData={fieldData} 
                                municipioNome={municipioNome} 
                            />
                        )}
                        {!readOnly && <button className="btn-confirm" onClick={handleSaveAll}>💾 Salvar Exame</button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExamModal;
